import styled from '@emotion/styled';
import {mixinSubHeading} from 'webapp-lib/styling';

export const HeaderRow = styled.div`
  display: flex;

  svg {
    width: 28px;
    height: 28px;
    fill: var(--color-core-primary);
  }
`;

export const ExclamationMark = styled.div<{show?: boolean}>`
  width: 32px;
  text-align: center;

  :after {
    color: var(--color-alerts-error);
    content: '${({show}): string => (show ? '!' : '')}';
  }
`;

export const TextWrapper = styled.div`
  flex-grow: 1;
  flex-basis: 0;
  min-width: 0;
  font-weight: var(--font-weight-thin);
  font-size: var(--font-size-default);
  line-height: 24px;
  word-break: break-word;
  white-space: break-spaces;
`;

export const FormHeader = styled.div`
  ${mixinSubHeading}
  margin-top: var(--gutter);
`;
